
import React, { Component } from 'react';
import './Prioritize.module.scss';

export default class BlueHeader extends Component {

  render() {
    const { subtitle, title } = this.props

    return (
        <div className="title">
          <h3>{subtitle}</h3>
          <h2>{title}</h2>
        </div>
    )
  }
}